import { z } from "zod";

export const HealthCategorySchema = z.enum(["nutrition", "injury", "mental", "recovery"]);
export type HealthCategory = z.infer<typeof HealthCategorySchema>;

export const HealthDifficultySchema = z.enum(["intermediate", "advanced"]);
export type HealthDifficulty = z.infer<typeof HealthDifficultySchema>;

export const HealthSectionSchema = z.object({
  heading: z.string(),
  content: z.string(),
  keyPoints: z.array(z.string()),
});
export type HealthSection = z.infer<typeof HealthSectionSchema>;

export const HealthSourceSchema = z.object({
  name: z.string(),
  url: z.string().url(),
});
export type HealthSource = z.infer<typeof HealthSourceSchema>;

export const HealthTopicSchema = z.object({
  id: z.string(),
  topicId: z.string(),
  category: HealthCategorySchema,
  title: z.string(),
  titleLocal: z.string(),
  summary: z.string(),
  summaryLocal: z.string(),
  sections: z.array(HealthSectionSchema),
  sources: z.array(HealthSourceSchema),
  tags: z.array(z.string()),
  difficulty: HealthDifficultySchema,
  updatedAt: z.string(),  // ISO 8601
});
export type HealthTopic = z.infer<typeof HealthTopicSchema>;
